import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loading", {
  state: () => ({
    timer: null,
    loading: false,
    count: 0,
  }),
  actions: {
    setLoading(loading) {
      if (loading) {
        this.count++;
        this.loading = true;
      } else if (this.count > 0) {
        this.count--;
        if (this.timer === null) {
          this.timer = setInterval(() => {
            if (this.count <= 0) {
              this.loading = false;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 150);
        }
      }
    },
  },
});
